export const reportGroupKeys = {
  all: ['reportGroup'],

  lists: () => [...reportGroupKeys.all, 'list'],

  classList: (classId?: number) => [...reportGroupKeys.lists(), classId ?? null],
};
